"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.jLog = void 0;
function logMessage(key, message, values, openGroups) {
    if (values === void 0) { values = []; }
    if (openGroups === void 0) { openGroups = true; }
    /* tslint:disable */
    if (console.group && console.groupCollapsed) {
        openGroups ? console.group(key) : console.groupCollapsed(key);
        console.log(message, values);
        console.groupEnd();
    }
    else {
        console.log(key, message, values);
    }
    /* tslint:enable */
}
/**
 * @description this is the logger for core sdk, this logger is made to show clean
 *              logs in the console and be configurable for the services/apps that use it
 *
 * @export {void}
 * @param {boolean} [log=false] set to true to set logs, default = false
 * @param {boolean} [openGroups=true] set true to collapse logs
 * @param {string} key the log key, generally this will be the name of the entity your logging for
 * @param {string} message the message
 * @param {any[]} [values=[]] the values you want to see in the logs
 */
function jLog(log, openGroups, key, message, values) {
    if (log === void 0) { log = true; }
    if (openGroups === void 0) { openGroups = true; }
    if (values === void 0) { values = []; }
    if (log) {
        logMessage(key, message, values, openGroups);
    }
}
exports.jLog = jLog;
//# sourceMappingURL=logging.js.map